/**
 * 软硬件信息-批量读取结果展示（领行/畅行专用）
 * 使用 `KlsVersionInfo`，仅展示 `lxVersionINfoFileds` 对应的字段
 */
import React, { useEffect, useMemo } from 'react';
import KlsVersionInfo from '@/components/klsVersionInfo';

interface HardwareInfoReadFormProps {
  data?: any; // 读取到的数据，来自任务明细中的 resultData 字符串
}

const HardwareInfoReadForm: React.FC<HardwareInfoReadFormProps> = ({ data }) => {
  // 解析 resultData（后端保存为字符串）
  const resultData = useMemo(() => {
    try {
      const resultDataStr = data?.resultData || '';
      return resultDataStr ? JSON.parse(resultDataStr) : {};
    } catch (err) {
      console.error('解析 HardwareInfo resultData 失败:', err);
      return {};
    }
  }, [data]);

  useEffect(() => {
    // 保留一个调试日志，方便排查数据结构
    // console.log('HardwareInfoReadForm resultData:', resultData);
  }, [resultData]);

  return (
    <div>
      <KlsVersionInfo data={resultData} isLingChang={true} />
    </div>
  );
};

export default HardwareInfoReadForm;
